// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1ff7C","right":"Footer_right__3t_Qr","buttons":"Footer_buttons__2jDlm"};